import { render } from "./customConfirmAction.vue?vue&type=template&id=b6ded820&scoped=true"
import script from "./customConfirmAction.vue?vue&type=script&lang=js"
export * from "./customConfirmAction.vue?vue&type=script&lang=js"

import "./customConfirmAction.vue?vue&type=style&index=0&id=b6ded820&scoped=true&lang=css"
import "./customConfirmAction.vue?vue&type=style&index=1&id=b6ded820&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6ded820"]])

export default __exports__